module.exports = "<div class=gmw-checkbox ng-click=toggle()> <div class=gmw-checkbox__box ng-class=\"{'gmw-checkbox__box--checked': !!model.$viewValue}\"> <svg class=gmw-checkbox__check> <use xlink:href=#thick-checkmark-icon></use> </svg> </div> <span ng-transclude></span> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/holding/modules/app/modules/common/directives/checkbox/checkbox.html
// module id = 257
// module chunks = 0